const { Lightbox } = require('../helpers/Lightbox');

export class Gallery {
    constructor(section = null) {
        if (!section) return;
        this.root = section;

        this.init();
    }

    init() {
        this.submitButton = this.root.querySelector('[js-submit-button]');
        this.imgWrappers = this.root.querySelectorAll('[js-image-wrapper]');
        this.allColumns = this.root.querySelectorAll('[js-col]');

        this.desktopPerPage = parseInt(
            this.root.getAttribute('data-desktop-per-page')
        );
        this.mobilePerPage = 6;

        this.isDesktopView = window.innerWidth > 1023.98;

        this.perPage = this.getPerPage();
        this.currentPage = 1;

        this.lightboxData = this.root.getAttribute('data-lightbox');
        this.lightboxInstance = null;
        this.lightboxTriggers = [];

        if (this.lightboxData) {
            this.lightboxInstance = new Lightbox(JSON.parse(this.lightboxData));
            this.lightboxTriggers =
                this.root.querySelectorAll('[js-show-lightbox]');
        }

        this.handleView();
        this.handleButtonView();
        this.events();
    }

    events() {
        window.addEventListener('resize', () => this.reset(false));

        if (this.submitButton) {
            this.submitButton.addEventListener(
                'click',
                this.onSubmitButtonClick.bind(this)
            );
        }

        if (this.lightboxTriggers.length) {
            this.lightboxTriggers.forEach(element => {
                element.addEventListener(
                    'click',
                    this.onLightboxTriggerClick.bind(this)
                );
            });
        }
    }

    onLightboxTriggerClick(e) {
        const element = e.target.closest('[js-show-lightbox]');
        if (!element || !this.lightboxInstance) return;

        const slideToShow = element.getAttribute('js-show-lightbox');

        this.lightboxInstance.openLightbox(slideToShow);
    }

    getPerPage() {
        return window.innerWidth < 1024
            ? this.mobilePerPage
            : this.desktopPerPage;
    }

    getColumnCount() {
        return window.innerWidth < 1024 ? 2 : 3;
    }

    reset(withoutReturn = false) {
        const width = window.innerWidth;

        if (width > 1023.98 && !this.isDesktopView) {
            this.isDesktopView = true;
        } else if (width <= 1023.98 && this.isDesktopView) {
            this.isDesktopView = false;
        } else if (!withoutReturn) {
            return;
        }

        this.perPage = this.isDesktopView
            ? this.desktopPerPage
            : this.mobilePerPage;

        this.maxPages = Math.ceil(this.imgWrappers.length / this.perPage);
        this.currentPage = 1;

        this.handleButtonView();
        this.handleView();
    }

    onSubmitButtonClick() {
        this.currentPage += 1;

        this.handleView();
        this.handleButtonView();
    }

    handleView() {
        if (!this.imgWrappers.length) return;

        const endIndex = this.currentPage * this.perPage;

        // reset columns
        this.assignToColumns(endIndex);

        this.imgWrappers.forEach((item, index) => {
            const shouldBeVisible = index < endIndex;

            if (!shouldBeVisible) {
                item.classList.add('hidden');
                return;
            }

            item.classList.remove('hidden');
        });
    }

    assignToColumns(endIndex) {
        const columnCount = this.getColumnCount();

        const columns = Array.from(this.allColumns).slice(0, columnCount);

        columns.forEach(col => (col.innerHTML = ''));

        const visibleItems = Array.from(this.imgWrappers).slice(0, endIndex);

        visibleItems.forEach((item, index) => {
            const colIndex = index % columnCount;
            columns[colIndex].appendChild(item);
        });
    }

    handleButtonView() {
        if (!this.submitButton) return;

        const maxPages = Math.ceil(this.imgWrappers.length / this.perPage);

        if (this.currentPage < maxPages) {
            this.submitButton.classList.remove('hidden!');
        } else {
            this.submitButton.classList.add('hidden!');
        }
    }
}

const sections = document.querySelectorAll('section.gallery');

if (sections.length) {
    sections.forEach(section => new Gallery(section));
}
